import { render } from "./OverviewBack.vue?vue&type=template&id=0d44f8cf"
import script from "./OverviewBack.vue?vue&type=script&lang=js"
export * from "./OverviewBack.vue?vue&type=script&lang=js"

import "./OverviewBack.vue?vue&type=style&index=0&id=0d44f8cf&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__